<template>
  <div class="clinic-history tab-personal-background">
    <h4 class="mb-2 text-blue fw-light">Tratamientos</h4>
    <a class="btn-add" @click="openModal()"><i class="las la-plus text-green"></i> <span class="p-2 pt-0 pb-0">Agregar Tratamiento</span></a>
    <hr />
    <h6 class="mb-2 text-blue fw-light">Tratamientos cargados</h6>
    <!-- Cards responsivas -->
    <div class="row" v-show="!loadStart">
      <div class="col-md-12 mb-3">
        <div class="card shadow-sm mb-3" v-show="items.length == 0 && !hasItems">
          <div class="card-body">  
            <p class="card-text">No existen Tratamientos cargados.</p>
          </div>
        </div>
        <div class="card shadow-sm mb-3" v-show="items.length > 0" v-for="item in items" :key="item.id">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="card-title m-0" v-if="item.status == 1"><small>Inicio: {{ item.start_date }}</small> - Estado: <b class="text-green">Activo</b></h6>
                <h6 class="card-title m-0" v-if="item.status == 2"><small>Inicio: {{ item.start_date }}</small> - Estado: <b class="text-muted">Suspendido</b></h6>
                <h6 class="card-title m-0" v-if="item.status == 3"><small>Inicio: {{ item.start_date }} - Fin: {{ item.end_date }}</small> - Estado: <b class="text-muted">Finalizado</b></h6>
              </div>
              <div class="d-flex justify-content-end m-3 mt-1 mb-1" >
                  <a class="fs-5 text-secondary" title="Ver o Editar Estudio" @click="editItem(item.id, item.files, item.treatmentName, item.treatmentDose, item.startDateNoFormat, item.endDateNoFormat, item.status, item.description, item.cieCodes)">
                      <i class="pointer ps-1 las la-pen p-2 text-blue"></i>
                  </a> 
                  <a class="fs-5 text-secondary" @click="deleteData(item.id)" title="Eliminar Estudio">
                      <i class="pointer border-start ps-1 las la-trash p-2 text-blue"></i>  
                  </a>
              </div>    
            </div>
            <p class="card-text">{{ item.treatmentName }}</p>
            <small><b>Dosis:</b></small>
            <p class="card-text">{{ item.treatmentDose }}</p>
            <div class="mb-3" v-if="item.cieCodes.length > 0">
              <small><b>Diagnóstico:</b></small> 
              <p v-for="itemCode in item.cieCodes" :key="itemCode.cie10Code" class="card-text text-muted">
                <small><span class="text-blue">Código: </span><b class="text-blue">{{ itemCode.cie10Code }}</b> - {{ itemCode.cie10Description }}</small>
              </p>
            </div>    
            <p class="card-text">{{ item.description }}</p>
            <p class="card-text text-muted">
              <small class="text-blue fw-light fst-italic">Profesional: {{ item.profName }}</small>
            </p>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal nueva nota -->
  <div class="modal fade" id="modalNuevaNota" tabindex="-1" aria-labelledby="modalNuevaNotaLabel" aria-hidden="true" data-bs-backdrop="false" data-bs-keyboard="false" style="z-index:1000000">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="ref == ''" class="modal-title" id="modalNuevaNotaLabel">Nuevo Tratamiento</h5>
          <h5 v-if="ref != ''" class="modal-title" id="modalNuevaNotaLabel">Editar Tratamiento</h5>
          <button type="button" class="btn-close" @click="closeModal()" aria-label="Cerrar"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label" for="treatmentName">Nombre del tratamiento:</label>
            <input type="text" v-model="treatmentName" attr-id="treatmentName" class="form-control" />
          </div>
          <div class="mb-3">
            <label class="form-label" for="treatmentDose">Dosis o frecuencia:</label>
            <input type="text" v-model="treatmentDose" attr-id="treatmentDose" class="form-control" />
          </div>
          <div class="row">
            <div class="col-md-6"> 
              <div class="mb-3">
                <label class="form-label" for="startDate">Inicio:</label>
                <input class="form-control" type="date" attr-id="startDate" v-model="startDate" />
              </div>    
            </div>
            <div class="col-md-6"> 
              <div class="mb-3">
                <label class="form-label" for="endDate">Fin:</label>
                <input class="form-control" type="date" attr-id="endDate" v-model="endDate" />
              </div>    
            </div>
          </div>
          <div class="row">
            <div class="col-md-6"> 
              <div class="mb-3">
                <label class="form-label" for="status">Estado:</label>
                <select class="form-control" attr-id="status" v-model="status">
                  <option value="1">Activo</option>
                  <option value="2">Suspendido</option>
                  <option value="3">Finalizado</option>
                </select>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="cie10Code">Diagnósticos CIE-10 (Opcional):</label>
            <!-- Contenedor del buscador con posición relativa -->
            <div class="row"> 
              <div class="col-md-6">
                <div class="mb-3 search-container">
                  <div class="">
                    <input type="text" id="busqueda" class="form-control" placeholder="Buscar enfermedad o condición o código..." autocomplete="off" v-model="searchCie" @keyup="buscarCategoria()">
                  </div>
                  <!-- Contenedor de resultados flotantes justo debajo del input -->
                  <div id="resultados-busqueda" class="mb-3"></div>
                </div>
              </div>
             </div>
            <div v-if="diagnoses.length > 0" class="mb-3"> 
              <strong>Diagnóstico CIE-10:</strong>
              <div  v-for="(d, index) in diagnoses" :key="index">    
                <div class="text-primary">
                  <a class="fs-5 text-danger" @click="removeDiagnosis(index)" title="Eliminar">
                      <i class="pointer ps-1 las la-trash p-2"></i>  
                  </a>
                  <span class="text-blue"><b>{{ d.cie10Code }}</b></span> {{ d.cie10Description }}
                  <hr class="m-0">
                </div>
              </div>
            </div>    
          </div>
          <div class="mb-3">
            <label class="form-label" for="description">Observaciones (Opcional):</label>
            <textarea class="form-control" attr-id="description" v-model="description" rows="3" placeholder=""></textarea>
          </div>
          <div class="service-edit">
            <div class="sec-files mb-4">
                <div>       
                    <div v-bind="getRootProps()" class="image-uploader">
                        <div id="spinner-container-imgs" class="spinner-container show"><img src="@/assets/imgs/spinner.webp" class="img-fluid" /></div>
                        <input id="imgsInput" v-bind="getInputProps()" />   
                        <p><i class="las la-file-medical text-primary"></i> Agrega o arrastra los archivos aquí</p>
                    </div>
                </div>
                <draggable
                    id= "container-drag-pics"
                    class="container-drag-pics"                        
                    :disabled="!enabledDrag"        
                    ghost-class="ghost"
                    @end="orderImgs"
                    itemKey=''>                   
                    <template #item="">
                        <div>    
                        </div>  
                    </template>      
                </draggable>
            </div> 
          </div>
          
             
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary w-50 p-3 pb-2 pt-2" @click="saveData()" :disabled="disabledBtn"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 11800000000; width: fit-content; margin-bottom: 0px;">
      <div id="toastcontainerClinic" class="w-25">
      </div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from 'bootstrap';
import { Modal } from "bootstrap";
import { useDropzone } from "vue3-dropzone";
import draggable from 'vuedraggable';
//let id = 1;
let filesLoaded = 0;
let arrayFiles = [];
let vm = '';
function updateFiles(){
    if(filesLoaded > 0){
        document.querySelector('.sec-files').classList.add('added');
    }else{
        document.querySelector('.sec-files').classList.remove('added');
    }
    let sum = 0;
    var htmlprint = '';
    Object.keys(arrayFiles).forEach(key => {
        if(arrayFiles[sum].type == 'pdf'){
            htmlprint = htmlprint+'<div id="'+arrayFiles[sum].id+'" class="list-item" data-draggable="true"><div class="thumbnail overflow-hidden"><img attr-link="'+arrayFiles[sum].baselink+'" attr-id="'+arrayFiles[sum].id+'" attr-type="'+arrayFiles[sum].type+'" class="img-fluid w-75" src="/img/pdf-icon.png" alt=""><span class="label"><div class="label-text">PDF</div></span><div class="actions"><div><i class="lar la-trash-alt text-primary delete-img" attr-id="'+arrayFiles[sum].id+'"></i></div><div><i class="las la-eye text-primary view-img" attr-link="'+arrayFiles[sum].baselink+'" attr-id="'+arrayFiles[sum].id+'" attr-type="'+arrayFiles[sum].type+'"></i></div></div></div></div>';
        }else if(arrayFiles[sum].type == 'image'){
            htmlprint = htmlprint+'<div id="'+arrayFiles[sum].id+'" class="list-item" data-draggable="true"><div class="thumbnail overflow-hidden"><img attr-link="'+arrayFiles[sum].baselink+'" attr-id="'+arrayFiles[sum].id+'" attr-type="'+arrayFiles[sum].type+'" class="img-fluid" src="'+arrayFiles[sum].link+'" alt=""><span class="label"><div class="label-text">IMAGEN</div></span><div class="actions"><div><i class="lar la-trash-alt text-primary delete-img" attr-id="'+arrayFiles[sum].id+'"></i></div><div><i class="las la-eye text-primary view-img" attr-link="'+arrayFiles[sum].baselink+'" attr-id="'+arrayFiles[sum].id+'" attr-type="'+arrayFiles[sum].type+'"></i></div></div></div></div>';
        }
        sum++;
    });
    document.querySelector('.container-drag-pics').innerHTML = htmlprint;
    var element =  document.querySelector(".delete-img");
    if (typeof(element) != 'undefined' && element != null){
        var elements = document.getElementsByClassName('delete-img');
        for(let el of elements) {
            el.addEventListener("click", function() {
                deleteFiles(this.getAttribute('attr-id'))
            });
        }
    }
    var element =  document.querySelector(".view-img");
    if (typeof(element) != 'undefined' && element != null){
        var elements = document.getElementsByClassName('view-img');
        for(let el of elements) {
            el.addEventListener("click", function() {
                viewFiles(this.getAttribute('attr-link'), this.getAttribute('attr-id'), this.getAttribute('attr-type'));
            });
        }
    }
}
function viewFiles(link, id, type){
  if(type == 'image'){
    vm.$root.openImg(link + id + "-big-image.webp"); 
  }else if(type == 'pdf'){
    vm.$root.openPdf(link + id + "-document.pdf");  
  }
}
function deleteFiles(val){
    document.getElementById(val).remove();
    filesLoaded--;
    if(filesLoaded > 0){
        document.querySelector('.sec-files').classList.add('added');
    }else{
        document.querySelector('.sec-files').classList.remove('added');
    }
    arrayFiles = [];
    let parent = document.querySelector("#container-drag-pics")
    let parent_node = parent.querySelectorAll('.list-item');
    for (var i = 0; i < parent_node.length; i++) {
        let arrayImg = { id: parent_node[i].id, type: parent_node[i].querySelector('div').querySelector('img').getAttribute('attr-type') , baselink: parent_node[i].querySelector('div').querySelector('img').getAttribute('attr-link') };
        arrayFiles.push(arrayImg)
    }
}
export default {
  name: "tabSessions",
  props: ['userId', 'consId'],
  data() {
    return {
      errorText: '',
      toastColor: '',
      toastBg: '',
      toastNumber: 0,
      modal: '',
      localZone: '',
      disabled: false,
      disabledBtn: false,
      loading: false,
      disabled: false,
      disabledBtn: false,
      loading: false,
      profName: '',
      diagnoses: [],
      searchCie: '',
      treatmentName: '',
      treatmentDose: '',
      startDate: '',
      endDate: '',
      status: 1,
      description: '',
      ref: '',
      items: [],
      next: 0,
      hasItems: false,
      loadStart: true,
      enabledDrag: true, //permite o no arrastrar los archivos
    };
  },
  setup() {
      function onDrop(acceptFiles, rejectReasons) {
          if(rejectReasons != ''){
              errorImgs(rejectReasons);
          }else{
              saveFilesImgs(acceptFiles);
          }
      }
      const errorImgs = (files) => {
        var ti = '';
          for (var x = 0; x < files.length; x++) {
              if(files[x].errors[0].code == "too-many-files"){
                ti = 'Solo puedes subir hasta 7 archivos';
              }else if(files[x].errors[0].code == "file-too-large"){
                ti = 'Los archivos no pueden pesar mas de 7mb';
              }else{
                ti = 'Hubo un error al intentar subir los archivos ('+files[x].errors[0].code+')';
              }
              document.querySelector('#spinner-container-imgs').classList.remove('open'); 
              var t = '<div id="tiobad" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header bg-danger text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body text-dark">'+ti+'</div></div></div>';
              try{
                  document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
                  var myAlert =document.getElementById('tiobad');//select id of toast
                  var bsAlert = new Toast(myAlert);//inizialize it
                  bsAlert.show();//show it
              }catch(e){

              }	
          } 
      }
      const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: true, maxSize: 7000000, minSize: 0, maxFiles: 7, accept: ['image/jpeg', 'image/jpg', 'application/pdf', 'application/msword'] });
      const saveFilesImgs = (files) => {
          document.querySelector('#spinner-container-imgs').classList.add('open'); 
          const formData = new FormData(); 
          for (var x = 0; x < files.length; x++) {
              formData.append("images[]", files[x]);
              filesLoaded++;   
          } 
          let url;
          if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
              url = 'https://api.animasana.net'
          }else if(window.location.host == 'api-qa.animasana.net'){
              url = 'https://api-qa.animasana.net' 
          }else{
              url = 'https://api-qa.animasana.net'
          }
          // post the formData to your backend where storage is processed. In the backend, you will need to loop through the array and save each file through the loop.
          const request = new Request(url+'/upload-consent-files.php', {
              method: 'POST',
              body: formData
          });
          fetch(request)
          .then(response => response.json())
          .then(data => { 
              document.querySelector('#spinner-container-imgs').classList.remove('open'); 
              let sum = 0;
              Object.keys(data).forEach(key => {
                  let arrayImg = { id: data[sum].id, link: data[sum].link, type: data[sum].type, baselink: data[sum].baselink };
                  arrayFiles.push(arrayImg)
                  sum++; 
              });
              var t = '<div id="tiok" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header bg-success text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body text-dark">Archivos subidos correctamente.</div></div></div>';
              try{
                  document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
                  var myAlert =document.getElementById('tiok');//select id of toast
                  var bsAlert = new Toast(myAlert);//inizialize it
                  bsAlert.show();//show it
              }catch(e){

              }		
              updateFiles();
          })
          .catch(error => {
              document.querySelector('#spinner-container-imgs').classList.remove('open'); 
              var t = '<div id="tiobad" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header bg-danger text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body text-dark">Revise su conexión de internet.</div></div></div>';
              try{
                  document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
                  var myAlert =document.getElementById('tiobad');//select id of toast
                  var bsAlert = new Toast(myAlert);//inizialize it
                  bsAlert.show();//show it
              }catch(e){

              }	
              return;
          })
      };
      return {
          getRootProps,
          getInputProps,    
      };
  },
  components: {
      draggable,
  }, 
  mounted: function () {
    this.localZone =  moment.tz.guess();
    var data = JSON.parse(localStorage.getItem('userData'));
    this.profName = data.userFirstName + ' ' + data.userLastName;
    vm = this;
    filesLoaded = 0;
    arrayFiles = [];
    this.findData();
  },
  unmounted: function () {
      try{
          this.modal.hide();
      }catch(e){

      }
  },
  methods: {
    addDiagnosis(code, desc) {
      const item = {
        cie10Code: code,
        cie10Description: desc
      };
      this.diagnoses.push(item); 
    },
    removeDiagnosis(index) {
      this.diagnoses.splice(index, 1);
    },
    resaltarCoincidencias(texto, termino) {
      const regex = new RegExp(`(${termino})`, 'gi');
      return texto.replace(regex, '<span style="color:#027be3;">$1</span>');
    },
    async buscarCategoria() {
      const resultadosDiv = document.getElementById('resultados-busqueda');
      resultadosDiv.innerHTML = '';
      var payload = {
          action: 'find-code-cie',
          browserCountry: this.$route.params.browserCountry,
          userLang: this.$route.params.userLang,
          urlcode: window.location.host,
          search: this.searchCie.trim(),    
      } 
      await axios.post('/index.php', payload).then(result => {  
        const json = result.data;
        if (json.encontrado && Array.isArray(json.results) && json.results.length) {
          const listGroup = document.createElement('div');
          listGroup.classList.add('list-group');
          for (const it of json.results) {
            const btn = document.createElement('button');
            btn.className = 'list-group-item list-group-item-action';

            // Resaltar coincidencia
            let btnText = `${it.title}` + (it.code ? ` [${it.code}]` : '');
            btnText = this.resaltarCoincidencias(btnText, this.searchCie.trim());
            btn.innerHTML = btnText;

            btn.dataset.id = it.id;
            btn.dataset.code = it.code;         // guardamos el código aquí
            btn.addEventListener('click', () => {
              // Actualizar selección
              if(btn.dataset.code != ''){
                this.addDiagnosis(btn.dataset.code, it.title);
              }
              resultadosDiv.innerHTML = '';
              this.searchCie = '';
            });

            listGroup.appendChild(btn);
          }
          resultadosDiv.appendChild(listGroup);
          // Mostrar el contenedor flotante
          resultadosDiv.style.display = 'block';
        }else{
          resultadosDiv.textContent = "No se encontró ninguna coincidencia.";
          resultadosDiv.style.display = 'block';
        }
      })
    },
    //ordena los archivos del drag and drop
    orderImgs(){
        arrayFiles = [];
        let parent = document.querySelector("#container-drag-pics")
        let parent_node = parent.querySelectorAll('.list-item');
        for (var i = 0; i < parent_node.length; i++) {
            let arrayImg = { id: parent_node[i].id, type: parent_node[i].querySelector('div').querySelector('img').getAttribute('attr-type') , baselink: parent_node[i].querySelector('div').querySelector('img').getAttribute('attr-link') };
            arrayFiles.push(arrayImg)
        }
    },
    editItem(id, files, treatmentName, treatmentDose, startDate, endDate, status, description, cie10Code){
      this.ref = id; 
      this.diagnoses = cie10Code;
      this.searchCie = '';
      this.treatmentName = treatmentName;
      this.treatmentDose = treatmentDose;
      this.startDate = startDate;
      this.endDate = endDate;
      this.status = status;
      this.description = description;
      arrayFiles = files;
      updateFiles();
      this.openModal();
    },
    openModal(){
        var modal = new Modal(document.querySelector('#modalNuevaNota'))
        this.modal = modal;
        modal.show()
    },
    closeModal(){
        this.modal.hide();
        var elems = document.querySelectorAll(".bad");
        [].forEach.call(elems, function(el) {
            el.classList.remove("bad");
        });
        filesLoaded = 0;
        arrayFiles = [];
        updateFiles();
        this.ref = '';
        this.diagnoses = [];
        this.searchCie = '';
        this.treatmentName = '';
        this.treatmentDose = '';
        this.startDate = '';
        this.endDate = '';
        this.status = 1;
        this.description = '';
        this.disabled = false;
        this.disabledBtn = false;
        this.loading = false;
    },
    async saveData(){
      var elems = document.querySelectorAll(".bad");
      [].forEach.call(elems, function(el) {
          el.classList.remove("bad");
      });
      var payload = {
          action: 'save-medical-treatments',
          browserCountry: this.$route.params.browserCountry,
          userLang: this.$route.params.userLang,
          urlcode: window.location.host,
          timezone: this.localZone,
          dataReceiver: this.userId,
          consId: this.consId,
          profName: this.profName,
          ref: this.ref,  
          treatmentName: this.treatmentName,
          treatmentDose: this.treatmentDose,
          startDate: this.startDate,
          endDate: this.endDate,
          status: this.status,
          description: this.description,
          cie10Code: this.diagnoses,  
          files: arrayFiles
      } 
      this.disabledBtn = true;
      this.loading = true;
      await axios.post('/index.php', payload).then(result => { 
        this.disabledBtn = false;
        this.loading = false;
        if(result.data.status == '200'){
          if(this.ref == ''){
            this.errorText = 'Tratamiento agregado';
          }else{
            this.errorText = 'Tratamiento actualizado';
          }
          this.toastBg = 'bg-info';
          this.toastColor = 'text-dark';
          this.toastNumber++;
          var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
          try{
              document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
              var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
              var bsAlert = new Toast(myAlert);//inizialize it
              bsAlert.show();//show it
          }catch(e){

          }		
          this.items = [];
          this.next = 0;
          this.findData();
          this.closeModal();
        }else{
          if(result.data.status == '400'){
            if(result.data.error == 'E2'){
              this.errorText = 'Debes ingresar el tipo de Tratamiento.';
              try{
                document.querySelector("[attr-id='treatmentName']").classList.add("bad"); 
                document.querySelector("[attr-id='treatmentName']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E3'){
              this.errorText = 'El tipo de Tratamiento ingresado no puede superar los 250 caracteres.';
              try{
                document.querySelector("[attr-id='treatmentName']").classList.add("bad"); 
                document.querySelector("[attr-id='treatmentName']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E4'){
              this.errorText = 'Debes ingresar la dosis o frecuencia.';
              try{
                document.querySelector("[attr-id='treatmentDose']").classList.add("bad"); 
                document.querySelector("[attr-id='treatmentDose']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E5'){
              this.errorText = 'La dosis o frecuencia ingresada no puede superar los 250 caracteres.';
              try{
                document.querySelector("[attr-id='treatmentDose']").classList.add("bad"); 
                document.querySelector("[attr-id='treatmentDose']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E6'){
              this.errorText = 'Debes ingresar la fecha de inicio del tratamiento.';
              try{
                document.querySelector("[attr-id='startDate']").classList.add("bad"); 
                document.querySelector("[attr-id='startDate']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E7'){
              this.errorText = 'La fecha de inicio del tratamiento ingresada es incorrecta.';
              try{
                document.querySelector("[attr-id='startDate']").classList.add("bad"); 
                document.querySelector("[attr-id='startDate']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E8'){
              this.errorText = 'Debes ingresar la fecha de finalización del tratamiento.';
              try{
                document.querySelector("[attr-id='endDate']").classList.add("bad"); 
                document.querySelector("[attr-id='endDate']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E9'){
              this.errorText = 'La fecha de finalización el tratamiento ingresada es incorrecta.';
              try{
                document.querySelector("[attr-id='endDate']").classList.add("bad"); 
                document.querySelector("[attr-id='endDate']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E10'){
              this.errorText = 'Debes ingresar las observaciones.';
              try{
                document.querySelector("[attr-id='description']").classList.add("bad"); 
                document.querySelector("[attr-id='description']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E11'){
              this.errorText = 'Las observaciones no pueden superar los 5000 caracteres.';
              try{
                document.querySelector("[attr-id='description']").classList.add("bad"); 
                document.querySelector("[attr-id='description']").select();
              }catch(e){

              }
            }else if(result.data.error == 'E12'){
              this.errorText = 'Un código CIE-10 ingresado no es válido o no se encuentra registrado.'; 
            }else if(result.data.error == 'E13'){
              this.errorText = 'Debes subir el/los archivos de los Tratamiento.'; 
            }
            this.toastBg = 'bg-danger';
            this.toastColor = 'text-dark';
            this.toastNumber++;
            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
            try{
                document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                var bsAlert = new Toast(myAlert);//inizialize it
                bsAlert.show();//show it
            }catch(e){

            }		
          }
        }
      })
      .catch(error => {
          this.disabledBtn = false;
          this.loading = false;
      })   
    },
    async deleteData(val){
      if (confirm("Estás por borrar un Tratamiento. ¿Deseás continuar?")) {
        var payload = {
            action: 'delete-medical-treatments',
            browserCountry: this.$route.params.browserCountry,
            userLang: this.$route.params.userLang,
            urlcode: window.location.host,
            ref: val,    
        } 

        this.disabledBtn = true;
        this.loading = true;
        await axios.post('/index.php', payload).then(result => { 

          this.disabledBtn = false;
          this.loading = false;
          if(result.data.status == '200'){    
            this.errorText = 'Tratamiento eliminado'; 
            this.toastBg = 'bg-info';
            this.toastColor = 'text-dark';
            this.toastNumber++;
            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
            try{
                document.querySelector('#toastcontainerClinic').insertAdjacentHTML("afterend", t);
                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                var bsAlert = new Toast(myAlert);//inizialize it
                bsAlert.show();//show it
            }catch(e){

            }		
            this.items = [];
            this.next = 0;
            this.findData();
            this.closeModal(); 
          }
        })
        .catch(error => {
            this.disabledBtn = false;
            this.loading = false;
        })   
      }
    },
    async findData(){
      var payload = {
          action: 'find-medical-treatments',
          browserCountry: this.$route.params.browserCountry,
          userLang: this.$route.params.userLang,
          urlcode: window.location.host,
          timezone: this.localZone,
          dataReceiver: this.userId,
          consId: this.consId,
          next: this.next,
      } 
      await axios.post('/index.php', payload).then(result => { 
        this.loadStart = false;
        let sum = 0;
        Object.keys(result.data).forEach(key => {
            this.hasItems = true;
            this.items.push(result.data[sum]); 
            sum++;                        
        });
        this.next = this.next+100;           
        
      })
      .catch(error => {
          
      })   
    },
  },
};
</script>

<style scoped>
.sec-file{
  display: block;
}
.clients-write .image-uploader, .clients .image-uploader{
  position: relative;
}
.service-edit .container-drag-pics .list-item .thumbnail{
  overflow: hidden;
}
.sec-file.added{
  display: flex;
}
.clinic-history .btn-add{
  display: flex;
  align-items: center;
  color: #212529;
  text-decoration: none;
  cursor: pointer;
}
.clinic-history .btn-add .la-plus {
    width: 30px;
    height: 30px;
    font-size: 24px;
    padding: 0;
    border-radius: 50%; 
    background: #00c7a2 ;
    color: #fff;
    text-decoration: none;
    padding: 3px;
}
.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - 83px);
}
.modal-dialog-scrollable {
    height: calc(100% - 89px);
}
/* Estilo para el contenedor flotante de resultados */
.search-container {
  position: relative;
}
@media screen and (max-width: 720px) {
  .search-container {
    position: relative;
    width: 100%;
  }
}
#resultados-busqueda {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 153px;
    overflow-y: auto;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 999;
    display: none;
    right: 0;
    border-radius: 0 0 9px 9px;
    overflow: hidden;
    overflow-y: auto;
}

/* Estilo para los resultados de búsqueda */
.list-group-item {
  cursor: pointer;
  transition: background-color 0.3s;
}

.list-group-item:hover {
  background-color: #f1f1f1;
}
.service-edit .container-drag-pics .list-item .thumbnail {
    overflow: hidden;
}
</style>